/* "Nirvik Ready for non-profits" (/guides/nonprofits): its own opening, ideas and playbook around the shared chapters. */
import why from './why.md?raw';
import ideas from './ideas.md?raw';
import playbook from './playbook.md?raw';
import { audienceGuide } from '../audience';

export const nonprofitsGuide = audienceGuide({
  audience: 'nonprofits',
  title: 'Nirvik Ready for non-profits',
  subtitle:
    'How non-profits protect the people they serve and train their staff and volunteers, from sign-up to workshops at their own centers.',
  reviewed: '2026-10-25',
  why: {
    title: 'Why Nirvik Ready for non-profits',
    summary: 'The people you serve, volunteers and staff',
    markdown: why,
  },
  ideas: { summary: 'Workshops, volunteer onboarding and funder reports', markdown: ideas },
  playbook: { summary: 'Your first 90 days, week by week', markdown: playbook },
});
